<app-nav-bar></app-nav-bar>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-2 col-sm-4 p-0">
      <app-side-bar> </app-side-bar>
    </div>
    <!-- <div class="empty"></div> -->
    <div class="content col-md-10 col-sm-8 ">
      <!-- <app-show-books></app-show-books> -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
